module.exports = __webpack_public_path__ + "static/img/avatar.b60c0014.png";